import { useQuery } from '@apollo/client';
import { RMMClient } from '../../../index';
import { GET_PENDING_CLIENTS } from '../../../DeviceGraphQL/queries/MDMSettingsPage';
import {
  PendingClientConfigList,
  GetPendingClientsVariables
} from '../../types';

interface UsePendingClientsParams {
  isOpen: boolean;
}

export const usePendingClients = ({ isOpen }: UsePendingClientsParams) => {
  // API call only - no data transformation
  return useQuery<
    { getMDMClientConfigList: PendingClientConfigList },
    GetPendingClientsVariables
  >(GET_PENDING_CLIENTS, {
    variables: {
      listInfo: { page: 1, pageSize: 50 },
      pendingSetup: true
    },
    fetchPolicy: 'network-only',
    client: RMMClient,
    skip: !isOpen // Only fetch when modal is open
  });
};
